/**
 * Estado de una operacion del backoffice que puede tardar y puede fallar
 * (ADM-04): subir una imagen, moverla, quitarla.
 *
 * Existe porque las tres pantallas que suben imagenes necesitan exactamente lo
 * mismo —saber si hay algo en curso, para apagar los botones, y el ultimo
 * error, para mostrarlo— y escribirlo en cada una dejaba tres pares de `useState`
 * que se desincronizan solos.
 *
 * El error se limpia al empezar la operacion siguiente: dejar el mensaje de un
 * fallo anterior arriba de una subida que acaba de salir bien es peor que no
 * mostrar nada.
 */
import { useState } from 'react';

import { mensajeDe } from '../utilidades/mensaje-error';

export interface SubidaImagen {
  subiendo: boolean;
  falla: string | null;
  /** Corre la operacion cuidando el estado. Nunca lanza: el error queda en `falla`. */
  subir(operacion: () => Promise<void>): Promise<void>;
}

export function useSubidaImagen(): SubidaImagen {
  const [subiendo, setSubiendo] = useState(false);
  const [falla, setFalla] = useState<string | null>(null);

  async function subir(operacion: () => Promise<void>): Promise<void> {
    setSubiendo(true);
    setFalla(null);

    try {
      await operacion();
    } catch (fallo) {
      setFalla(mensajeDe(fallo));
    } finally {
      setSubiendo(false);
    }
  }

  return { subiendo, falla, subir };
}
